<button class="btn p-0 m-0 w-fit-content border-0 d-flex gap-8 align-items-center" *ngIf="item"
        (click)="changeInclusion(item)"
        [ngClass]="{'text-primary selected': item.included}">
  <span class="rounded-circle d-block aspect-ratio_1-1" [ngClass]="{'bg-primary': item.included}"></span>
  {{ item.name ? item.name : item }}
  <span class="material-icons font-18">apartment</span>
</button>
